import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import { useStaticQuery, graphql } from "gatsby";
import { MenuItem } from "@material-ui/core";
import { _ } from "../utils/i18n";
import FilterButton from "../components/filter-button";
import FilterButtonGroup from "../components/filter-button-group";

import DropDown from "../components/dropdown";

const PostFilter = ({ current, input = "button", isSub, type = "post" }) => {
  const { posts, cat } = useStaticQuery(
    graphql`
      query {
        posts: allWpContentNode(
          filter: { nodeType: { in: ["Post", "Case"] } }
        ) {
          edges {
            node {
              contentTypeName
              ... on WpPost {
                title
                categories {
                  nodes {
                    slug
                    databaseId
                    uri
                    name
                  }
                }
              }
              ... on WpCase {
                title
                categories {
                  nodes {
                    slug
                    databaseId
                    uri
                    name
                  }
                }
              }
            }
          }
        }
        cat: allWpCategory(
          filter: { wpParent: { node: { databaseId: { eq: 28 } } } }
        ) {
          edges {
            node {
              slug
              uri
              name
              description
              databaseId
            }
          }
        }
      }
    `
  );

  const linksub =
    type === "post"
      ? _("/blogg")
      : type === "case"
      ? _("/case")
      : type === "kontakt"
      ? _("/kontakt")
      : "";

  var c = {};

  {
    type === "all"
      ? posts &&
        posts.edges &&
        posts.edges.map(({ node }) =>
          node.categories?.nodes
            ?.filter((cat) => cat.name !== "Ukategorisert")
            .map((cat) => (c[cat.name] = cat.uri))
        )
      : posts &&
        posts.edges &&
        posts.edges
          .filter(({ node }) => node.contentTypeName === type)
          .map(({ node }) =>
            node.categories?.nodes
              ?.filter((cat) => cat.name !== "Ukategorisert")
              .map((cat) => (c[cat.name] = cat.uri))
          );
  }

  const catList = () =>
    input === "button" ? (
      <FilterButtonGroup>
        {type !== "all" && (
          <Link to={`${linksub}/`} className="no-underline">
            <FilterButton
              label={_("Alle artikler")}
              variant={isSub ? "outlined" : "default"}
            />
          </Link>
        )}
        {Object.keys(c).map((key, i) =>
          type === "post" ? (
            <Link
              key={i}
              to={c[key].replace("/category", "")}
              className="no-underline"
            >
              <FilterButton
                label={key.replace("&#038;", "&").replace("&amp;", "&")}
                variant={current && current === key ? "default" : "outlined"}
              />
            </Link>
          ) : (
            type === "case" && (
              <Link
                key={i}
                to={c[key].replace("/category", "").replace("/blogg", "/case")}
                className="no-underline"
              >
                <FilterButton
                  label={key.replace("&#038;", "&").replace("&amp;", "&")}
                  variant={current && current === key ? "default" : "outlined"}
                />
              </Link>
            )
          )
        )}
      </FilterButtonGroup>
    ) : (
      <DropDown label={_("Velg avdeling")}>
        {cat.edges.map((location, i) => (
          <Link key={i} to={`${_("/kontakt/")}${location.node.slug}/`}>
            <MenuItem>
              {location.node.name.replace("&#038;", "&").replace("&amp;", "&")}
            </MenuItem>
          </Link>
        ))}
      </DropDown>
    );

  return <div>{catList()}</div>;
};

PostFilter.propTypes = {
  current: PropTypes.string,
  input: PropTypes.string,
  isSub: PropTypes.bool,
  type: PropTypes.string,
};

PostFilter.defaultProps = {
  current: undefined,
  input: undefined,
  isSub: undefined,
  type: undefined,
};

export default PostFilter;
